import getUserMailboxInfo from 'owa-client-ids/lib/utils/getUserMailboxInfo';
import { PerformanceCoreDatapoint as BasePerformanceCoreDatapoint } from 'owa-analytics';
import type { DatapointOptionsForPerformanceDatapoint } from 'owa-analytics-types';

export class PerformanceCoreDatapoint extends BasePerformanceCoreDatapoint {
    constructor(eventName: string, options?: DatapointOptionsForPerformanceDatapoint) {
        super(eventName, getUserMailboxInfo(), options);
    }
}
